<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="theTable"
          :external-loading="loading"
          :remote-create-item="remoteCreateItem"
          :remote-update-item="remoteUpdateItem"
          :remote-delete-item="remoteDeleteItem"
          :remote-get-item="remoteGetItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :search-key-word="searchKeyWord"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :create-params-callback="createParamsCallback"
          :extra-input-call-back="extraInputCallBack"
          :extra-input-validation="extraInputValidation"
          @reset="handleReset"
          @openEditDialog="openEditDialog"
          @setupExtraInput="listenExtraInput"
          @openDeleteDialog="openDeleteDialog"
          @getList="listenGetList"
        >
          <template v-slot:item.assignedSchema="{item}">
            <div v-if="item.coachInfo?.coachCommissionSchemas?.length">
              {{ item.coachInfo?.coachCommissionSchemas?.length }}
            </div>
            <div
              v-else
              style="color:red"
            >
              0
            </div>
          </template>
          <template v-slot:item.prependActions="{ item }">
            <v-icon
              v-show="checkTerminationDate(item)"
              class="action-icon mr-2"
              style="color:red"
            >
              mdi-close-octagon-outline
            </v-icon>

            <v-icon
              v-show="checkTerminationDateBefore(item)"
              class="action-icon mr-2"
              style="color:blue"
            >
              mdi-timer-remove-outline
            </v-icon>

            <v-icon
              v-if="showSchemaAction"
              class="action-icon mr-2"
              @click="handleCommission(item)"
            >
              mdi-currency-usd
            </v-icon>
            <v-icon
              class="action-icon mr-2"
              @click="handleDocument(item)"
            >
              mdi-file-document-plus-outline
            </v-icon>
          </template>
          <template v-slot:extra-top>
            <div class="pl-5 pr-5">
              <div>
                <p>
                  <span class="text-h5">Center</span>

                  <v-btn
                    v-show="!selectCenterButton"
                    style="margin-left : 30px"
                    depressed
                    class="mr-5"
                    color="primary"
                    @click="unselectAllCenter()"
                  >
                    Unselect all
                  </v-btn>

                  <v-btn
                    v-show="selectCenterButton"
                    style="margin-left : 30px"
                    depressed
                    class="mr-5"
                    color="primary"
                    @click="selectAllCenter()"
                  >
                    Select all
                  </v-btn>
                </p>
              </div>
              <v-row
                v-show="centerList.length==0"
                justify="center"
              >
                <v-col cols="3">
                  No Data
                </v-col>
              </v-row>
              <v-row v-show="centerList.length>0">
                <v-col
                  v-for="item in centerList"
                  :key="item.id"
                  class="pa-2"
                >
                  <!-- input-value="true" -->
                  <v-checkbox
                    v-model="selectedCenterList"
                    :disabled="deleteDialog"
                    :label="item.code"
                    :value="item.id"
                    @change="eventCheckbox"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>
            <div class="pl-5 pr-5">
              <div>
                <p>
                  <span class="text-h5">Course</span>

                  <v-btn
                    v-show="!selectCourseButton"
                    style="margin-left : 30px"
                    depressed
                    class="mr-5"
                    color="primary"
                    @click="unselectAllCourse()"
                  >
                    Unselect all
                  </v-btn>

                  <v-btn
                    v-show="selectCourseButton"
                    style="margin-left : 30px"
                    depressed
                    class="mr-5"
                    color="primary"
                    @click="selectAllCourse()"
                  >
                    Select all
                  </v-btn>
                </p>
              </div>
              <v-row
                v-show="courseList.length==0"
                justify="center"
              >
                <v-col cols="3">
                  No Data
                </v-col>
              </v-row>
              <v-row v-show="courseList.length>0">
                <v-col
                  v-for="item in courseList"
                  :key="item.id"
                  class="pa-2"
                >
                  <!-- input-value="true" -->
                  <v-checkbox
                    v-model="selectedCourseList"
                    :disabled="deleteDialog"
                    :label="item.courseName"
                    :value="item.id"
                    @change="eventCourseCheckbox"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>
          </template>

          <template v-slot:extraInput>
            <v-container>
              <v-card>
                <v-card-text>
                  <ImageCropper
                    v-model="avatarFile"
                  >
                  </ImageCropper>
                </v-card-text>
              </v-card>
            </v-container>

            <v-container>
              <v-card>
                <v-card-title>
                  Role
                </v-card-title>
                <v-card-text>
                  <v-radio-group
                    v-model="radios"
                    :disabled="deleteDialog"
                    :rules="raidoRule"
                    row
                  >
                    <v-row>
                      <v-col
                        v-for="item in sysRoleList"
                        :key="item.id"
                        class="pa-2"
                      >
                        <!-- input-value="true" -->
                        <!-- <v-checkbox @change="eventCheckSysRoleEditbox" v-model="selectedRoleList" :label="item.name"
                    :value="item.id"></v-checkbox> -->

                        <v-radio
                          :disabled="deleteDialog"
                          :label="item.name"
                          :value="item.id"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-container>

            <v-container>
              <v-card>
                <v-card-title>
                  Center
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      v-for="item in centerList"
                      :key="item.id"
                      class="pa-2"
                    >
                      <v-checkbox
                        v-model="selectedCoachCenterList"
                        :disabled="deleteDialog"
                        :label="item.code"
                        :value="item.id"
                        :rules="selectedCoachCenterListRule"
                        required
                        @change="eventCoachCenterCheckbox"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>

            <v-container>
              <v-card>
                <v-card-title>
                  Course
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      v-for="item in courseList"
                      :key="item.id"
                      class="pa-2"
                    >
                      <v-checkbox
                        v-model="selectedCoachCourseList"
                        :disabled="deleteDialog"
                        :label="item.courseName"
                        :value="item.id"
                        :rules="selectedCoachCourseListRule"
                        @change="eventCoachCourseCheckbox"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
            <v-container>
              <v-text-field
                v-for="item in extraInput"
                :key="item.propName"
                v-model="item.value"
                :disabled="deleteDialog"
                :label="item.label"
                outlined
                :rules="item.Rules"
                required
              ></v-text-field>

              <universal-input
                v-if="editDialog"
                v-model="editTerminationDate"
                :config="editTerminationDateConfig"
              >
              </universal-input>
            </v-container>
          </template>
        </crudtable>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="documentDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Document Management</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <div class="text-h5">
            Document Management:
          </div>
          <v-card>
            <v-card-text>
              <v-row>
                <!-- use v-for to loop v-col in subfolderList -->
                <v-col
                  v-for="item in subfolderList"
                  :key="item.id"
                  :ref="el => itemRefs.push(el)"
                >
                  <v-card>
                    <v-card-title>
                      {{ item.label }}
                      <v-btn
                        icon
                        color="primary"
                        small
                        @click="triggerUpload(item)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <!-- {{ JSON.stringify(item) }} -->
                      <ul v-if="item.files.length>0">
                        <li
                          v-for="file in item.files"
                          :key="file.id"
                        >
                          <!-- {{ JSON.stringify(file) }} -->
                          <div class="d-flex">
                            <a
                              :href="getFileLink(file.fileUrl)"
                            >{{ file.fileRecord.fileName }}</a>
                            <v-spacer></v-spacer>
                            <div>
                              <v-icon
                                small
                                @click="removeDocument(file)"
                              >
                                mdi-close
                              </v-icon>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div v-else>
                        No files
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <input
                ref="selectFileRef"
                class="d-none"
                type="file"
                capture="environment"
                accept="image/*"
                @change="handleFileChange"
              />
            </v-card-text>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
    <CoachCommissionSchemaDialog
      v-model="commissionDialog"
      :user-record="currentCoach"
      @close="handleCloseDialog"
    >
    </CoachCommissionSchemaDialog>
  </div>
</template>

<script setup>
import sha512 from 'crypto-js/sha512'
import {
  mdiAccountOutline,
  mdiCheckUnderline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,

  // terminate icon
  mdiCloseOctagonOutline,

  // not achive the terminated date
  mdiTimerRemoveOutline,
} from '@mdi/js'
import { ref, onMounted, reactive, computed, watch } from 'vue'
import moment from '@/utils/moment'
import {
  createItem as remoteCreateItem, deleteItem as remoteDeleteItem,
  fetchList, updateItem as remoteUpdateItem, getItem as remoteGetItem,
  listSubFolder, listCoachFiles, uploadCoachFile, deleteDocument,
  listCoachCommission,
} from '@/api/coach'

import ImageCropper from '@/components/Avatar/ImageCropper'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'
import { getUserData } from '@/utils/auth'
import { objectToFormData, loading as loadingOverlay, base64ToFile, hasRole } from '@/utils/helper'

import CoachCommissionSchemaDialog from './CoachProfiles/CoachCommissionSchemaDialog'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'

let timeout
let tempAllCenterList = []
let tempAllCourseList = []

const token = ref('')

const showSchemaAction = computed(() => {
  const roleArr = hasRole([5, 7])
  if (roleArr.length > 0) {
    return true
  }

  return false
})

onMounted(() => {
  const userData = getUserData()
  if (userData.userToken) {
    token.value = userData.userToken.token
  }
})

function getFileLink(fileUrl) {
  return `${process.env.VUE_APP_BASE_API}${fileUrl}/${token.value}`
}

const selectCenterButton = ref(false)
const selectCourseButton = ref(false)

const itemRefs = ref([])

const selectFileRef = ref(null)
const selectedSubfolder = ref({
  id: -1,
})
function triggerUpload(item) {
  console.log('selectFileRef.value', selectFileRef.value)
  selectedSubfolder.value = item
  selectFileRef.value.click()
}

const selectFile = ref(null)

const defaultCurrentCoach = {
  id: -1,
  fullName: '',
  email: '',
  joinDate: '0001-01-01T00:00:00.000Z',
  mobileNo: '',
  coachInfo: {
    userRecordID: -1,
    position: 'Full Time Coach',
    joinDate: '0001-01-01T00:00:00.000Z',
    basicSalary: 0,
    id: -1,
  },
}
const currentCoach = ref(JSON.parse(JSON.stringify(defaultCurrentCoach)))

const documentDialog = ref(false)

const subfolderList = ref([
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
  {
    files: [],
  },
])

function checkTerminationDate(item) {
  // console.log('checkTerminationDate')
  let result = false

  if (item.terminatedDate != null) {
    const currentTime = moment()

    const compareTime = moment(item.terminatedDate)

    if (currentTime.isAfter(compareTime)) {
      result = true
    }
  }

  return result
}

function checkTerminationDateBefore(item) {
  // console.log('checkTerminationDateBefore')
  let result = false

  if (item.terminatedDate != null) {
    const currentTime = moment()

    const compareTime = moment(item.terminatedDate)

    if (currentTime.isBefore(compareTime)) {
      result = true
    }
  }

  return result
}

function fetchDocuments() {
  if (selectFileRef.value) {
    console.log('selectFileRef.value.value', selectFileRef.value.value)
    if (selectFileRef.value.value) {
      selectFileRef.value.value = ''
    }
    console.log('selectFileRef.value.value', selectFileRef.value.value)
  }
  if (currentCoach.value.id === -1) {
    return
  }
  listCoachFiles({
    id: currentCoach.value.id,
  }).then(res => {
    console.log('listCoachFiles res', res)
    if (res.data && res.data.items) {
      for (let j = 0; j < subfolderList.value.length; j += 1) {
        subfolderList.value[j].files = []
        for (let i = 0; i < res.data.items.length; i += 1) {
          const item = res.data.items[i]
          const subfolder = subfolderList.value[j]

          // console.log('subfolder.id item.fileSubfolderID', subfolder.id, item.fileSubfolderID)
          // console.log('subfolder.id === item.fileSubfolderID', subfolder.id === item.fileSubfolderID)
          if (subfolder.id === item.fileSubfolderID) {
            subfolderList.value[j].files.push(item)
          }
        }
      }
    }
    console.log('subfolderList', subfolderList)
    loadingOverlay(false)
  })
}
function removeDocument(item) {
  loadingOverlay(true)
  console.log('removeDocument', item)
  deleteDocument(item.id).then(res => {
    console.log('deleteDocument', res)
    if (res.code === 20000) {
      fetchDocuments()
    }
  })
}

function handleFileChange(e) {
  console.log('selectedSubfolder', selectedSubfolder)
  if (selectFileRef.value.files && selectFileRef.value.files.length > 0) {
    const formData = objectToFormData({
      coachInfoID: currentCoach.value.coachInfo.id,
      fileSubfolderID: selectedSubfolder.value.id,
    })
    formData.append('coachFile', selectFileRef.value.files[0])
    loadingOverlay(true)
    uploadCoachFile(formData).then(res => {
      console.log('uploadCoachFile res', res)
      fetchDocuments()
    }).finally(() => {
      loadingOverlay(false)
    })
  }
}

// function fetchCommission() {
//   console.log('currentCoach.value', currentCoach.value)
//   if (currentCoach.value.id === -1) {
//     return
//   }
//   listCoachCommission({
//     id: currentCoach.value.coachInfo.id,
//   }).then(res => {
//     if (res.data && res.data.items) {
//       // for (let j = 0; j < subfolderList.value.length; j += 1) {
//       //   subfolderList.value[j].files = []
//       //   for (let i = 0; i < res.data.items.length; i += 1) {
//       //     const item = res.data.items[i]
//       //     const subfolder = subfolderList.value[j]

//       //     // console.log('subfolder.id item.fileSubfolderID', subfolder.id, item.fileSubfolderID)
//       //     // console.log('subfolder.id === item.fileSubfolderID', subfolder.id === item.fileSubfolderID)
//       //     if (subfolder.id === item.fileSubfolderID) {
//       //       subfolderList.value[j].files.push(item)
//       //     }
//       //   }
//       // }
//     }
//     loadingOverlay(false)
//   })
// }

const commissionDialog = ref(false)
function handleCommission(item) {
  commissionDialog.value = true
  currentCoach.value = item

  // fetchCommission()
}

function handleDocument(item) {
  console.log('handleDocument', item)
  documentDialog.value = true
  currentCoach.value = item
  fetchDocuments()
}

onMounted(() => {
  listSubFolder().then(res => {
    console.log('listSubFolder res', res)
    subfolderList.value = []
    if (res.data && res.data.items) {
      for (let index = 0; index < res.data.items.length; index += 1) {
        const item = res.data.items[index]
        item.files = []
        subfolderList.value.push(item)
      }
    }
  })
})

const theTable = ref(null)
function handleReset() {
  console.log('handleReset')
  inputConfigs.value[2].disabled = false
  inputConfigs.value[3].label = 'Password'
  inputConfigs.value[4].label = 'Confirm Password'
  avatarFile.value = ''
}
function onEditDialog(action) {
  console.log('action', action)
}
const store = useStore()
const loading = ref(false)
const searchKeyWord = ref('')

const centerList = ref([])
const selectedCenterList = ref([])

const courseList = ref([])
const selectedCourseList = ref([])

const editDialog = ref(false)
const editIndex = ref(-1)
const hintSentence = ref('')

const editSysRoleList = ref([])

const sysRole = ref(null)

const sysRoleList = ref([])

const userSysRoleList = ref([])

const radios = ref(0)

const selectedCoachCenterList = ref([])
const selectedCoachCourseList = ref([])

const deleteDialog = ref(false)

const editBasicSalary = ref(null)
const editTerminationDate = ref(null)

const editPosition = ref('')

const avatarFile = ref('')

const extraInputValidation = ref(false)

const selectedCoachCenterListRule = [
  // v =>  {console.log('basicSalary', typeof v)   },
  v => {
    if (selectedCoachCenterList.value.length == 0) {
      return 'Please select one of them'
    }

    return null
  },

]

const selectedCoachCourseListRule = [
  // v =>  {console.log('basicSalary', typeof v)   },
  v => {
    if (selectedCoachCourseList.value.length == 0) {
      return 'Please select one of them'
    }

    return null
  },

]

const raidoRule = [
  // v =>  {console.log('basicSalary', typeof v)   },
  v => {
    if ((radios.value == 0)) { return 'Please select one of them' }
  },

]

const extraInput = ref([{

  value: editBasicSalary,
  propName: 'basicSalary',
  label: 'Basic Salary',

  // type: {inputType : 'number'},

  Rules: [
    // v => !!v | 'BasicSalary is requierd',
    v => {
      // console.log('rule', v)
      if (v === null) {
        return 'BasicSalary is requierd'
      }

      if (typeof v === 'string') {
        const bool = /^\d+$/.test(v)
        if (!bool) {
          return 'Please enter number'
        }
      }
    },

  ],

  // typeof v  === "number" || 'please enter number'
},
{

  value: editPosition,
  propName: 'Position',
  label: 'Position',
  Rules: [
    v => !!v || 'Position is required',
    v => typeof v === 'string' || 'Please enter Position name',
  ],

},

])

const editTerminationDateConfig = ref(
  {
    value: editTerminationDate,
    propName: 'TerminationDate',
    label: 'Termination Date',
    type: {
      name: 'datepicker',
    },
  },
)

onMounted(() => {
  store.dispatch('center/list', {})
    .then(result => {
      console.log('center result', result)
      centerList.value = result.items
      for (let index = 0; index < centerList.value.length; index += 1) {
        // selectedCenterList.value = [...centerList.value.code]
        const value = centerList.value[index].id
        selectedCenterList.value.push(value)

        // console.log('selectedCenterList.value', selectedCenterList.value)
      }
      tempAllCenterList = selectedCenterList.value

      console.log('centerList.value', centerList.value)

      store.dispatch('course/list', {})
        .then(courseReponse => {
          courseList.value = courseReponse.items

          for (let index = 0; index < courseList.value.length; index += 1) {
            // selectedCenterList.value = [...centerList.value.code]
            const value = courseList.value[index].id
            selectedCourseList.value.push(value)

            // console.log('selectedCourseList.value', selectedCourseList.value)
          }
          tempAllCourseList = selectedCourseList.value
          theTable.value.fetchData()
        }).catch(err => {
          console.log('err', err)
        })

      // theTable.value.fetchData()
    })
    .catch(err => {
      console.log('err', err)
    })

  store.dispatch('sysRole/coachlist', {}).then(result => {
    sysRoleList.value = result.items
    console.log('sysRole/coachlist', sysRoleList.value)
  })
    .catch(err => {
      console.log('err', err)
    })
})

function unselectAllCenter() {
  selectedCenterList.value = []
  selectCenterButton.value = true
  loading.value = true
}

function selectAllCenter() {
  selectedCenterList.value = tempAllCenterList
  selectCenterButton.value = false
  loading.value = true
}

function unselectAllCourse() {
  selectedCourseList.value = []
  selectCourseButton.value = true
  loading.value = true
}

function selectAllCourse() {
  selectedCourseList.value = tempAllCourseList
  selectCourseButton.value = false
  loading.value = true
}

// list parameters
function createParamsCallback(params) {
  params.centerList = selectedCenterList.value
  params.courseList = selectedCourseList.value

  return params
}

function eventCheckbox(e) {
  // console.log('eventCheckbox', e)
  selectedCenterList.value = [...e]
  loading.value = true
  if (timeout) {
    clearTimeout(timeout)
  }

  timeout = setTimeout(() => {
    theTable.value.fetchData()
  }, 1500)
}

function eventCourseCheckbox(e) {
  // console.log('eventCheckbox', e)
  selectedCourseList.value = [...e]
  loading.value = true

  if (timeout) {
    clearTimeout(timeout)
  }

  timeout = setTimeout(() => {
    theTable.value.fetchData()
  }, 1500)
}

function eventCheckSysRoleEditbox(e) {
  console.log('eventCheckSysRoleEditbox', e)

  // selectedRoleList.value = [...e]
}

function listenExtraInput(e) {
  console.log('listenExtraInput(e)', e)

  radios.value = 0
  selectedCoachCenterList.value = []

  userSysRoleList.value = e.sysUserRoles

  const duplicatedRecords = sysRoleList.value.filter(item1 => userSysRoleList.value.some(item2 => item2.sysRoleID === item1.id))

  // console.log('duplicatedRecords', duplicatedRecords)
  if (duplicatedRecords) { radios.value = duplicatedRecords[0].id }

  const temp = []
  for (let index = 0; index < e.coachCenter.length; index += 1) {
    temp.push(e.coachCenter[index].centerID)
  }

  console.log('listenExtraInputtemp', temp)
  selectedCoachCenterList.value = [...temp]

  const CoachCoursetemp = []
  for (let index = 0; index < e.coachCourse.length; index += 1) {
    CoachCoursetemp.push(e.coachCourse[index].courseID)
  }
  selectedCoachCourseList.value = [...CoachCoursetemp]

  editBasicSalary.value = e.coachInfo.basicSalary

  editPosition.value = e.coachInfo.position

  editTerminationDate.value = e.terminatedDate

  // if (editTerminationDate != ''){
  //   e.coachInfo.position
  // }

  try {
    // avatarFile.value = computed(() => process.env.VUE_APP_BASE_API + e.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')
    avatarFile.value = process.env.VUE_APP_BASE_API + e.avatar
  } catch (err) {
    console.log('errerr', err)
    avatarFile.value = ''
  }

  // console.log(e)
  // console.log('editBasicSalary.value' , editBasicSalary.value)

  // console.log('editPosition.value' , editPosition.value)
}

function openEditDialog(e) {
  // console.log('openEditDialog', typee)

  if (e === 'create') {
    editDialog.value = false

    inputConfigs.value[2].disabled = true
    inputConfigs.value[3].label = 'Password'
    inputConfigs.value[4].label = 'Confirm Password'
  }

  if (e === 'edit') {
    const userData = getUserData()
    console.log('userData', userData)

    let disableTheColumn = true
    for (let index = 0; index < userData.userRecord.sysUserRoles.length; index++) {
      if (userData.userRecord.sysUserRoles[index].sysRoleID == 5 || userData.userRecord.sysUserRoles[index].sysRoleID == 7) {
        {
          disableTheColumn = false
        }
      }
    }

    editDialog.value = true
    inputConfigs.value[2].disabled = disableTheColumn
    inputConfigs.value[3].label = 'Reset Password'
    inputConfigs.value[4].label = 'Confirm Reset Password'
  }
}

function eventCoachCenterCheckbox(e) {
  console.log('eventCoachCenterCheckbox', e)

  selectedCoachCenterList.value = [...e]
}

function eventCoachCourseCheckbox(e) {
  console.log('eventCoachCourseCheckbox', e)

  selectedCoachCourseList.value = [...e]
}

async function extraInputCallBack(e) {
  // edit upload

  console.log('after save')
  e.CoachCenterList = selectedCoachCenterList.value
  e.CoachCourseList = selectedCoachCourseList.value
  console.log('e.CoachCenterList', e.CoachCenterList)

  e.SysRoleID = radios.value

  console.log('extraInputCallBackeditBasicSalary', editBasicSalary.value)
  console.log('extraInputCallBackediteditPosition', editPosition.value)
  e.BasicSalary = editBasicSalary.value
  e.Position = editPosition.value

  if (e.confirmedPassword == e.password && (e.password != '' && e.confirmedPassword != '')
    && (e.password !== undefined && e.confirmedPassword !== undefined)) {
    e.confirmedPasswordSha = sha512(e.confirmedPassword.trim()).toString()
  }

 
  if (editTerminationDate.value != ''){
    e.EditTerminationDate =  editTerminationDate.value
  }
 


  // formData.append('CoachCenterList', selectedCoachCenterList.value)
  // formData.append('CoachCourseList', selectedCoachCourseList.value)
  // formData.append('SysRoleID', radios.value)
  // formData.append('BasicSalary', editBasicSalary.value)
  // formData.append('Position', editPosition.value)

  const formData = objectToFormData(e)

  if (avatarFile.value == '') {
    // if (extraInputValidation.value == true)
    //   alert('please upload an avatar file')

    extraInputValidation.value = false
  }

  if (avatarFile.value != '') {
    extraInputValidation.value = true
    const avatarFileObj = await base64ToFile(avatarFile.value, 'avatar.png')
    formData.append('avatarFile', avatarFileObj)
  }

  return formData
}

function listenGetList(e) {
  loading.value = false
}

watch(selectedCenterList, newValue => {
  if (newValue.length == 0 || newValue.length == tempAllCenterList.length) {
    loading.value = true
    if (timeout) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(() => {
      theTable.value.fetchData()
    }, 1500)
  }
})

watch(selectedCourseList, newValue => {
  if (newValue.length == 0 || newValue.length == tempAllCourseList.length) {
    loading.value = true
    if (timeout) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(() => {
      theTable.value.fetchData()
    }, 1500)
  }
})

function openDeleteDialog(e) {
  console.log('openDeleteDialog', e)

  if (e === false) {
    deleteDialog.value = e
    editDialog.value = false
    radios.value = 0
    selectedCoachCenterList.value = []
    selectedCoachCourseList.value = []

    userSysRoleList.value = []

    editBasicSalary.value = null

    editPosition.value = null

    editTerminationDate.value = null
  } else {
    deleteDialog.value = true

    // const duplicatedRecords = sysRoleList.value.filter(item1 => userSysRoleList.value.some(item2 => item2.sysRoleID === item1.id))

    // if (duplicatedRecords) { radios.value = duplicatedRecords[0].id }

    radios.value = e.sysUserRoles[0].sysRoleID

    const temp = []
    for (let index = 0; index < e.coachCenter.length; index += 1) {
      temp.push(e.coachCenter[index].centerID)
    }
    selectedCoachCenterList.value = [...temp]

    const CoachCoursetemp = []
    for (let index = 0; index < e.coachCourse.length; index += 1) {
      CoachCoursetemp.push(e.coachCourse[index].courseID)
    }
    selectedCoachCourseList.value = [...CoachCoursetemp]

    editBasicSalary.value = e.coachInfo.basicSalary

    editPosition.value = e.coachInfo.position
  }
}

const sysRoleConfig = ref([{
  propName: 'sysRoleID',
  label: 'Role',
  required: true,
  type: {
    name: 'checkboxGroup',
    isHorizontal: true,
    groupItems: [
      { propName: 'COACH_FT', itemValue: 2, itemName: 'sysRoleID', label: 'COACH(FT)' },
      { propName: 'COACH_FL', itemValue: 3, itemName: 'sysRoleID', label: 'COACH(FL)' },
    ],
  },
}])

const formConfig = {
  delete: { title: 'Terminate' },
  title: 'CoachProfiles',
  searchLabel: 'Search for mobile, name and email',
  headers: [
    // { value: 'id', text: 'Id' },
    { value: 'userNo', text: 'User No' },
    { value: 'fullName', text: 'Name' },

    { value: 'sysUserRoles.sysRole.name', text: 'Role', sortable: false },
    { value: 'coachInfo.position', text: 'Position' },

    // { value: 'firstName', text: 'FirstName' },
    // { value: 'lastName', text: 'LastName' },
    { value: 'mobileNo', text: 'Mobile' },

    // { value: 'email', text: 'Email' },
    { value: 'gender', text: 'Gender' },
    { value: 'terminatedDate', text: 'Terminated' },
    { value: 'assignedSchema', text: 'Schema' },

    // { value: 'hkid', text: 'HKID' },
    // { value: 'coachInfo.basicSalary', text: 'BasicSalary' },
    // { value: 'joinDate', text: 'JoinDate' },

    { value: 'actions', text: 'Actions', sortable: false },
  ],

  customColumns: [
    {
      name: 'assignedSchema',
    },
    {

      name: 'sysUserRoles.sysRole.name',
      callback(sysRole, record) {
        let role = ''
        for (let index = 0; index < record.sysUserRoles.length; index += 1) {
          role += `${record.sysUserRoles[index].sysRole.name},`
        }
        role = role.slice(0, -1)

        return role
      },

    },
    {
      name: 'joinDate',
      callback(JoinDate, record) {
        const value = moment(record.coachInfo.joinDate).format('YYYY-MM-DD')

        return value
      },
    },

    {
      name: 'terminatedDate',
      callback(terminatedDate, record) {
        let value = ''
        if (record.terminatedDate != null) {
          value = moment(record.terminatedDate).format('YYYY-MM-DD')
        }

        return value
      },
    },

  ],
}

const icons = ref({
  mdiSquareEditOutline,
  mdiFileDocumentOutline,
  mdiDotsVertical,
  mdiDeleteOutline,
  mdiPlus,
  mdiExportVariant,
  mdiAccountOutline,
})
const inputConfigs = ref([
  {
    propName: 'firstName',
    label: 'First Name',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'First Name is required',
      ],
    },

  },
  {
    propName: 'lastName',
    label: 'Last Name',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'Last Name is required',
      ],
    },
  },

  {
    propName: 'hkid',
    label: 'HK ID',
    type: {
      rules: [
        // e.g. a123456(7)
        v => (typeof v === 'string' && v.length === 10) || 'HKID is required',
      ],
    },
  },

  {
    hint: (editDialog.value ? 'if you are in edit mode, you can no input any password in this textbox that you dont change password' : ''),
    propName: 'password',
    label: 'Password',
    type: {
      inputType: 'password',
      rules: [
        // e.g. a123456(7)
        v => {
          console.log('editDialog.value', editDialog.value)
          if (editDialog.value) {
            // if (typeof v === 'string' && v.length == 0) { return null }

            if (v === undefined) { return null }
            console.log('typeof v password', typeof v)
            console.log('typeof v password2', v)
            if ((v.length == 0 && typeof v === 'string')) { return null }

            if (!(v.length >= 8 && typeof v === 'string')) {
              return 'password is required or length is more than 8'
            }
          } else {
            console.log('editDialog.value2222', editDialog.value)
            if (!(typeof v === 'string' && v.length >= 8)) {
              return 'password is required or length is more than 8'
            }
          }
        },
      ],
    },
  },
  {
    propName: 'confirmedPassword',
    label: 'Confirm Password',
    type: {
      inputType: 'password',
      rules: [

        // e.g. a123456(7)
        v => {
          if (editDialog.value) {
            //  if (typeof v === 'string' && v.length == 0) { return null }
            //  console.log('typeof v password', typeof v)
            //  console.log('typeof v password2',   v)
            if (v === undefined) { return null }

            if ((v.length == 0 && typeof v === 'string')) { return null }

            if (!(v.length >= 8 && typeof v === 'string')) {
              return 'password is required or length is more than 8'
            }

            const { confirmedPassword, password } = theTable.value.getEditedItem()

            if (password !== confirmedPassword && typeof v === 'string') {
              return 'not same password'
            }
          } else {
            if (!(typeof v === 'string' && v.length >= 8)) {
              return 'password is required or length is more than 8'
            }
            const { confirmedPassword, password } = theTable.value.getEditedItem()

            // const { password } = theTable.value.getEditedItem()
            if (password !== confirmedPassword) {
              return 'not same password'
            }
          }
        },
      ],
    },
  },

  {
    propName: 'birthday',
    label: 'Birthday',

    type: {
      name: 'datepicker',
      allowedDates: (val => {
        const result = moment(val).isBefore(moment())

        // console.log('allowedDates val result', val, result)

        return result
      }),
      rules: [
        // e.g. 1992-01-01
        v => (typeof v === 'string' && v.length === 10) || 'Birthday is required',
      ],
    },
  }, {
    propName: 'gender',
    label: 'Gender',
    required: true,
    type: {
      name: 'radioGroup',
      isHorizontal: true,
      groupItems: [
        { itemValue: 'M', itemName: 'M', label: 'Male' },
        { itemValue: 'F', itemName: 'F', label: 'Female' },
      ],
      rules: [
        // e.g. 1992-01-01
        v => !!v || 'please select gender',
      ],

    },
  }, {
    propName: 'mobileNo',
    label: 'Telephone',
    required: true,
    type: {
      rules: [
        // e.g. 91123232
        v => (typeof v === 'string' && v.length === 8) || 'Telephone is required',
      ],
    },
  }, {
    propName: 'email',
    label: 'Email',
    required: true,
    type: {
      rules: [
        // e.g. 91123232
        v => (typeof v === 'string' && v.length > 0) || 'Email is required',
      ],
    },

  },

  // { md: 12, propName: 'firstName ', label: 'FirstName' , },
  // { md: 12, propName: 'lastName ', label: 'LastName' },
  // { md: 12, propName: 'nickName  ', label: 'NickName ' },
  // { md: 12, propName: 'userName  ', label: 'UserAccount' },
  // { md: 12, propName: 'gender  ', label: 'Gender ' , hint: 'M or F'},

  // { md: 12, propName: 'email  ', label: 'Email '  },
  // { md: 12, propName: 'Password  ', label: 'password' },
  // { md: 12, propName: 'hKID  ', label: 'HKID ' },
  // { md: 12, propName: 'mobileNo   ', label: 'MobileNo' },

  // { md: 12, propName: 'birthday ', label: 'Birthday ' },
])

function handleCloseDialog() {
  documentDialog.value = false
  currentCoach.value = JSON.parse(JSON.stringify(defaultCurrentCoach))
  theTable.value.fetchData()
}

</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
